<template>
  <div
    class="d-flex flex-column align-center"
    style="width: 250px"
  >
    <canvas ref="teamsCanvas"></canvas>
    <v-btn
      class="whatsAppBtn"
      color="#464fba"
      :href="channel.connectionString"
      target="_blank"
      ><v-icon
        color="white"
        class="mr-2"
        >supervisor_account</v-icon
      >
      <span class="white--text">Open Teams Chat</span></v-btn
    >
  </div>
</template>

<script>
import QRCode from 'qrcode';
export default {
  name: 'TeamsButton',
  props: {
    channel: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.createQRCode();
  },
  methods: {
    async createQRCode() {
      let teamsCanvas = this.$refs.teamsCanvas;
      await QRCode.toCanvas(teamsCanvas, this.channel.connectionString);
    },
  },
};
</script>
